<template>
    <div>
        <transition name="modal" v-if="showModal">
            <div class="overlay" @click="closeModal">
                <div class="panel" @click.stop>
                    <div class="icon-wrapper">
                        <span class="c-icon is-close is-current-color" @click="closeModal"></span>
                    </div>
                    <div class="panel-title">クーポンが追加されました。</div>
                    <p class="panel-message">適用するにはクーポン一覧から選択してください。</p>
                    <a class="c-round-btn is-full-width is-dark" @click="closeModal" id="agree">戻る</a>
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        openModal: function () {
            this.showModal = true
        },
        closeModal: function () {
            this.showModal = false;
        }
    }
}
</script>

<style lang="scss">
.overlay {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1045;
    transition: all .5s ease;
    text-align: center;
    font-weight: bold;
}

.panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    padding: 8px 24px 24px 24px;

    .icon-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-bottom: -8px;
        width: 100%;
        .c-icon {
            transform: translate(16px, 0px);
        }
    }
    .panel-title {
        color:  #202830;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        line-height: 130%;
    }
    .panel-message {
        color: #202830;
        text-align: center;
        font-size: 16px;
        font-weight: 300;
        line-height: 130%;
        margin-bottom: 16px;
    }
}

@media screen and (max-width: 767px) {
    .panel {
        top: 50%;
    }
}

.modal-enter,
.modal-leave-active {
    opacity: 0;
}

.modal-enter .panel,
.modal-leave-active .panel {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

</style>
